// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
const getExtensionFromFilename = (filename) => {
  return (filename ?? "").split(".")?.pop() ?? "";
};

export default getExtensionFromFilename;
